<form class="f-col blank-form" [formGroup]="predefinedReasonForm">
    <div class="section-heading">
        <h2 class="h2-heading">{{content?.['b2b.managecompany.tppredefinereasons']}} <div class="dot">.</div> <span class="optional">{{content?.['b2b.managecompany.optional']}}</span></h2>
        <a role="button" class="link"
        *ngIf="commonObjPipes.GetAllPreDefinedReasonsDetails.pipe.length>0 && !Addnew" (click)="addNewPredefinedReasons()"><mat-icon fontSet="material-symbols-outlined"
            class="edit-icon">add</mat-icon>{{content?.['b2b.managecompany.addnew']}}</a>
    </div>

    <!-- <app-cam-empty-state></app-cam-empty-state> -->

    <div class="section-content" *ngIf="Addnew">
        <div class="inner-contentsection">
            <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label">{{content?.['b2b.managecompany.tpselectpolicy']}} </label>
                        <mat-radio-group aria-label="Select an option" formControlName="policyFlag">
                            <mat-radio-button [value]="true">{{content?.['b2b.managecompany.tpinpolicy']}}</mat-radio-button>
                            <mat-radio-button [value]="false">{{content?.['b2b.managecompany.tpoutofpolicy']}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>

            <div class="f-row">
                <div class="f-col cm-language-dropdwon">
                    <!-- <ng-select autoBlurSelect [items]="commonObjPipes.GetAllCountryLanguage.pipe" bindValue="languageCode" bindLabel="languageName" [placeholder]="content?.['b2b.managecompany.tpselectlanguage'] || 'Select Language'" formControlName="languageCode"></ng-select>
                    <mat-error *ngIf="predefinedReasonForm.get('languageCode')?.invalid && predefinedReasonForm.get('languageCode')?.touched">Select Language is required.</mat-error> -->
                    
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.tpselectlanguage'] || 'Select Language'}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix>{{ branchSelect.panelOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                        <mat-select #branchSelect formControlName="languageCode">
                            <mat-option *ngFor="let lang of commonObjPipes.GetAllCountryLanguage.pipe" [value]="lang.languageCode">
                            {{ lang.languageName }}
                            </mat-option>
                        </mat-select>
                         <mat-error *ngIf="predefinedReasonForm.get('languageCode')?.invalid && predefinedReasonForm.get('languageCode')?.touched">Select Language is required.</mat-error>
                    </mat-form-field>
                    
                </div>
            </div>

            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.tpreasoncode']}}</mat-label>
                        <input matInput formControlName="reasonCode" (keypress)="blockInvalidCharacters1($event)" (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)">
                        <mat-error *ngIf="predefinedReasonForm.get('reasonCode')?.hasError('required')">Reason Code is required.</mat-error>
                        <mat-error *ngIf="predefinedReasonForm.get('reasonCode')?.hasError('maxlength')">Reason Code cannot exceed more than 50 characters.</mat-error>
                    </mat-form-field>
                </div>
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.tpreasonname']}}</mat-label>
                        <input matInput formControlName="reasonName" (keypress)="_CommonService.blockSpecialChar($event)" (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)">

                        <mat-error *ngIf="predefinedReasonForm.get('reasonName')?.hasError('required')">Reason Name is required.</mat-error>
                        <mat-error *ngIf="predefinedReasonForm.get('reasonName')?.hasError('maxlength')">Reason Name cannot exceed more than 100 characters.</mat-error>
                        <mat-error *ngIf="predefinedReasonForm.get('reasonName')?.hasError('minlength')">Reason Name must be at least 2 characters. </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label"> {{content?.['b2b.managecompany.tpreasontypecolon']}}</label>
                        <mat-radio-group aria-label="Select an option" formControlName="reasonType">
                            <mat-radio-button [value]="true">{{content?.['b2b.managecompany.tpacceptance']}}</mat-radio-button>
                            <mat-radio-button [value]="false">{{content?.['b2b.managecompany.tpdenied']}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>

            <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label">{{content?.['b2b.managecompany.tpdefaultlowestfare']}}</label>
                        <mat-radio-group aria-label="Select an option" formControlName="defaultLF">
                            <mat-radio-button [value]="true">{{content?.['b2b.managecompany.tpacceptance']}}</mat-radio-button>
                            <mat-radio-button [value]="false">{{content?.['b2b.managecompany.tprejection']}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>

            <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label">{{content?.['b2b.managecompany.tpproduct']}}</label>
                        <div class="f-row mat-check-group">
                            <!-- <mat-checkbox class="checkbox-wrapper" [value]="'All'">All</mat-checkbox>
                            <mat-checkbox class="checkbox-wrapper" [value]="'Flight'">Flight</mat-checkbox> -->
                            <mat-checkbox class="checkbox-wrapper" [value]="product.productCode" *ngFor="let product of commonObjPipes.ProductList.pipe"
                            (change)="onCheckboxChange($event, product.productCode)"
                            [checked]="selectedProducts.includes(product.productCode.trim())"
                            >{{product.productName ==='Other Products' ? content?.['b2b.managecompany.ancillaries'] : product.productName }}</mat-checkbox>
                   
                        </div>
                    </div>

                    <!-- <mat-error *ngIf="predefinedReasonForm.get('product')?.hasError('required')">Product selection is required!</mat-error> -->

                </div>
            </div>

            <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label">{{content?.['b2b.managecompany.status']}}</label>
                        <mat-radio-group aria-label="Select an option" formControlName="status">
                            <mat-radio-button [value]="true">{{content?.['b2b.managecompany.active']}}</mat-radio-button>
                            <mat-radio-button [value]="false">{{content?.['b2b.managecompany.inactive']}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>
        </div>

        <div class="inner-action">
            <button mat-button class="button--secondary-small" (click)="onCancel()">{{content?.['b2b.managecompany.cancel']}}</button>
            <button mat-button class="button--primary-small" [class.disabled]="predefinedReasonForm.invalid" (click)="onSave()">{{content?.['b2b.managecompany.save']}}</button>
        </div>
    </div>

    <div class="section-table data-listing" *ngIf="commonObjPipes.GetAllPreDefinedReasonsDetails.pipe.length>0 && !Addnew">
        <table mat-table [dataSource]="commonObjPipes.GetAllPreDefinedReasonsDetails.pipe" class="mat-elevation-z0">
            <!-- Position Column -->
            <ng-container matColumnDef="Reason Code">
                <th mat-header-cell *matHeaderCellDef>{{content?.['b2b.managecompany.tpreasoncode']}} </th>
                <td mat-cell *matCellDef="let element"> {{element.reasonCode}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="Reason Name">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.tpreasonname']}} </th>
                <td mat-cell *matCellDef="let element"> {{element.reasonName}} </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="Reason Type">
                <th mat-header-cell *matHeaderCellDef>{{content?.['b2b.managecompany.tpreasontype']}}  </th>
                <td mat-cell *matCellDef="let element"> {{element.reasonType ? content?.['b2b.managecompany.tpacceptance']: content?.['b2b.managecompany.tpdenied']}} </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="Policy Flag">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.tppolicyflag']}} </th>
                <td mat-cell *matCellDef="let element"> {{element.policyFlag ? content?.['b2b.managecompany.tpinpolicy'] : content?.['b2b.managecompany.tpoutofpolicy']}} </td>
            </ng-container>

            <ng-container matColumnDef="Status">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.ddstatus']}} </th>
                <td mat-cell *matCellDef="let element" class="status-tag">
                    <span
                        [ngClass]="element.status ? 'status-active' : 'status-inactive'">
                        {{ element.status ? content?.['b2b.managecompany.active'] : content?.['b2b.managecompany.inactive'] }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="Action">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.ddactions']}} </th>
                <td mat-cell *matCellDef="let element" class="onclick-links">
                    <!-- <a class="onclick-cell primary-link" (click)="onEdit(element)">Edit</a>
                    <a class="onclick-cell warm-link" (click)="onRemove(element)">Remove</a> -->
                    <a tabindex="0" role="button" aria-label="Edit item" class="onclick-cell primary-link" (keydown.enter)="onEdit(element)" (click)="onEdit(element)"><mat-icon fontSet="material-symbols-outlined">Edit</mat-icon></a>
                    <a tabindex="0" role="button" aria-label="Remove item" class="onclick-cell warm-link" (keydown.enter)="onRemove(element)" (click)="onRemove(element)"><mat-icon fontSet="material-symbols-outlined">Delete</mat-icon></a>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <ng-container *ngIf="!isLoading && commonObjPipes.GetAllPreDefinedReasonsDetails.pipe.length==0 && !Addnew">
        <app-cam-empty-state (myEvent)="handleEvent($event)" [heading]="content?.['b2b.managecompany.tpnopredefinereasontitle']"
            [content]="content?.['b2b.managecompany.tpnopredefinereasondesc']"
            [navigateTo]="'/cam/company-management/pre-defined-reasons'">
        </app-cam-empty-state>
    </ng-container>
</form>

<ng-template #selectionWarning>
    <div class="custom-dialog">
        <div class="d-justify-bw">
            <div class="custom-dialog__left">
                <div class="mat-dialog-title custom-dialog__title d-justify-bw">
                    <h2 class="mat-dialog-title"> {{ content?.warningList?.[0]?.title || content?.['b2b.managecompany.confirmchanges'] || 'Confirm changes' }}</h2>
                    <!-- <div class="custom-overlay-close">
                        <mat-icon fontSet="material-symbols-outlined" class="close_icon" (click)="CloseDialog(false)">close</mat-icon>
                    </div> -->
                </div>
                <mat-dialog-content class="custom-dialog__text">
                    <div class="custom-dialog__description"> Are you sure you want to remove this Pre defined reasons?</div>
                </mat-dialog-content>
                <mat-dialog-actions>
                    <div class="dialog-actions-right">
                        <button class="button--secondary-small" mat-button (click)="CloseDialog(false)">{{ content?.['b2b.managecompany.cancel'] || 'Cancel' }}</button>
                        <button class="button--primary-small" mat-button (click)="CloseDialog(true)">{{ content?.warningList?.[0]?.confirmCTAText || 'Confirm' }}</button>
                    </div>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>